import { render, staticRenderFns } from "./TrainingCenter.vue?vue&type=template&id=cdc70c1c&scoped=true"
import script from "./TrainingCenter.vue?vue&type=script&lang=js"
export * from "./TrainingCenter.vue?vue&type=script&lang=js"
import style0 from "./TrainingCenter.vue?vue&type=style&index=0&id=cdc70c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc70c1c",
  null
  
)

export default component.exports